import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=8ac579d6&scoped=true&lang=pug&"
import script from "./task-list.vue?vue&type=script&lang=js&"
export * from "./task-list.vue?vue&type=script&lang=js&"
import style0 from "./task-list.vue?vue&type=style&index=0&id=8ac579d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac579d6",
  null
  
)

export default component.exports